import {Suspense} from "react";
import {Redirect as RouterRedirect, Route} from "react-router-dom";
import BackdropSpinner from "../../../shared/components/backdrop-spinner/BackdropSpinner";
import Redirect from "../../redirect/Redirect";

const RouteWrapper = ({
                          component: Component,
                          layout: Layout,
                          showRoute,
                          shouldRedirect,
                          redirectTo,
                          ...rest
                      }) => {
    return (
        showRoute ?
            <Route {...rest} render={(props) =>
                !shouldRedirect ? <Layout>
                    <Suspense fallback={<BackdropSpinner/>}>
                        <Component {...props} />
                    </Suspense>
                </Layout> : <RouterRedirect to={redirectTo}/>
            }/> : <Redirect/>
    );
}

export default RouteWrapper;
